import React from 'react'
import { UserList } from '../../../../user/components/UserList'
import useSingleOrganization from '../../../hooks/useSingleOrganization'

export default function OrganizationUserList({pageSize}:{pageSize?: number}) {
      const { organizationId, singleOrganizationQuery: {isLoading} } = useSingleOrganization()
        if(isLoading) return <>...</>   
  return (
    <UserList.List orgnizationId={organizationId} pageSize={pageSize}/>
  )
}
